<template>
  <f7-app :params="f7params">
    <creators-area-banner
      v-if="!!userCoursesCount || showCreatorsAreaBanner"
    ></creators-area-banner>

    <f7-view
      main
      :class="[
        'safe-areas',
        { 'banner-visible': !!userCoursesCount || showCreatorsAreaBanner },
      ]"
      url="/"
      :push-state="true"
      push-state-separator=""
    >
      <f7-navbar v-if="user === null" no-hairline>
        <f7-nav-left>
          <f7-link class="logo" href="/" reload-current ignore-cache>
            <img src="/static/Logo.svg" class="hide-on-tablet" alt="Logo" />
            <img src="/static/logoIcon.png" class="show-on-tablet" alt="Logo" />
          </f7-link>

          <f7-menu>
            <f7-menu-item
              :text="$root.$i18n.locale"
              icon-f7="chevron_down"
              icon-size="12"
              dropdown
            >
              <f7-menu-dropdown center>
                <f7-menu-dropdown-item
                  text="EN"
                  @click="setLang('en')"
                ></f7-menu-dropdown-item>
                <f7-menu-dropdown-item
                  text="RU"
                  @click="setLang('ru')"
                ></f7-menu-dropdown-item>
                <f7-menu-dropdown-item
                  text="ES"
                  @click="setLang('es')"
                ></f7-menu-dropdown-item>
                <f7-menu-dropdown-item
                  text="PT"
                  @click="setLang('pt')"
                ></f7-menu-dropdown-item>
              </f7-menu-dropdown>
            </f7-menu-item>
          </f7-menu>
        </f7-nav-left>

        <!-- <f7-nav-title class="hide-on-mobile">
          {{ $t(`page_home.title`) }}
        </f7-nav-title> -->

        <f7-nav-right>
          <f7-button
            fill
            large
            round
            @click="$f7.loginScreen.open('#loginScreen')"
          >
            {{ $t(`log_in`) }}
          </f7-button>
        </f7-nav-right>
      </f7-navbar>

      <f7-navbar v-else no-hairline>
        <f7-nav-left>
          <f7-link
            class="logo margin-right"
            href="/"
            reload-current
            ignore-cache
          >
            <img src="/static/Logo.svg" class="hide-on-tablet" alt="Logo" />
            <img src="/static/logoIcon.png" class="show-on-tablet" alt="Logo" />
          </f7-link>

          <f7-menu>
            <f7-menu-item
              :text="$root.$i18n.locale"
              icon-f7="chevron_down"
              icon-size="12"
              dropdown
            >
              <f7-menu-dropdown center>
                <f7-menu-dropdown-item
                  text="EN"
                  @click="setLang('en')"
                ></f7-menu-dropdown-item>
                <f7-menu-dropdown-item
                  text="RU"
                  @click="setLang('ru')"
                ></f7-menu-dropdown-item>
                <f7-menu-dropdown-item
                  text="ES"
                  @click="setLang('es')"
                ></f7-menu-dropdown-item>
                <f7-menu-dropdown-item
                  text="PT"
                  @click="setLang('pt')"
                ></f7-menu-dropdown-item>
              </f7-menu-dropdown>
            </f7-menu-item>
          </f7-menu>

          <user-info-item
            :emoji="user.status.image"
            :title="`${user.lastName} ${user.name}`"
            :link-text="user.status.name"
            href="/profile/"
            class="hide-on-tablet"
          ></user-info-item>

          <user-info-item
            :title="user.balance"
            :link-text="$t('by_more_credits')"
            href="/balance/"
            emoji="$"
          ></user-info-item>

          <f7-button class="hide-on-tablet" fill large round href="/balance/">
            {{ $t(`by_more_credits`) }}
          </f7-button>

          <user-info-item
            emoji="🎓"
            :title="$t(`my_courses`)"
            :link-text="`${purchasedCourseCount} ${$t(
              `purchased`
            )} ${favoritesCourseCount} ${$t(`favorites`)}`"
            href="/dashboard/"
            class="hide-on-tablet"
          ></user-info-item>
        </f7-nav-left>

        <f7-nav-right>
          <f7-button
            class="hide-on-tablet text-color-black"
            icon-f7="square_arrow_right"
            icon-color="black"
            @click="logout"
          >
            {{ $t(`log_out`) }}
          </f7-button>

          <f7-link
            href="/profile/"
            icon-f7="bars"
            icon-size="28"
            icon-color="black"
            class="show-on-tablet"
          ></f7-link>
        </f7-nav-right>
      </f7-navbar>
    </f7-view>

    <f7-login-screen
      id="loginScreen"
      class="login-screen"
      @loginscreen:close="handleLoginscreenClose"
    >
      <f7-view>
        <f7-page login-screen>
          <f7-navbar no-hairline>
            <f7-nav-right>
              <f7-link
                icon-f7="multiply"
                icon-size="28"
                @click="$f7.loginScreen.close('#loginScreen')"
              ></f7-link>
            </f7-nav-right>
          </f7-navbar>
          <f7-login-screen-title>
            <h2>{{ loginScreenTitle.title }}</h2>
            <span>{{ loginScreenTitle.subtitle }}</span>
          </f7-login-screen-title>

          <div v-if="loginScreen.step === 1">
            <f7-list form @submit.prevent="signIn">
              <f7-list-input
                type="text"
                floating-label
                clear-button
                :label="$t(`form_fields.phone_number.placeholder`)"
                :error-message-force="!!loginScreen.phone.error"
                :error-message="loginScreen.phone.error"
                :value="loginScreen.phone.value"
                @input="loginScreen.phone.value = $event.target.value"
              ></f7-list-input>
            </f7-list>
          </div>

          <div v-if="loginScreen.step === 2">
            <code-input
              :loading="false"
              :fields="4"
              :auto-focus="true"
              @change="(val) => (loginScreen.smsCode = val)"
              @complete="signIn"
            />
          </div>

          <f7-list
            v-if="loginScreen.step === 3"
            no-hairlines
            form
            @submit.prevent="signIn"
          >
            <f7-list-input
              type="text"
              floating-label
              clear-button
              :label="$t(`form_fields.name.placeholder`)"
              :error-message-force="!!loginScreen.name.error"
              :error-message="loginScreen.name.error"
              :value="loginScreen.name.value"
              @input="loginScreen.name.value = $event.target.value"
            ></f7-list-input>

            <f7-list-input
              type="text"
              floating-label
              clear-button
              :label="$t(`form_fields.last_name.placeholder`)"
              :error-message-force="!!loginScreen.lastName.error"
              :error-message="loginScreen.lastName.error"
              :value="loginScreen.lastName.value"
              @input="loginScreen.lastName.value = $event.target.value"
            ></f7-list-input>

            <f7-list-input
              type="email"
              inputmode="email"
              floating-label
              clear-button
              :label="$t(`form_fields.email.placeholder`)"
              :error-message-force="!!loginScreen.email.error"
              :error-message="loginScreen.email.error"
              :value="loginScreen.email.value"
              @input="loginScreen.email.value = $event.target.value"
            ></f7-list-input>

            <f7-list-input
              type="text"
              floating-label
              clear-button
              :label="$t(`form_fields.referral.placeholder`)"
              :error-message-force="!!loginScreen.referral.error"
              :error-message="loginScreen.referral.error"
              :value="loginScreen.referral.value"
              @input="loginScreen.referral.value = $event.target.value"
            ></f7-list-input>
          </f7-list>

          <f7-block>
            <f7-button
              class="custome-large"
              type="submit"
              fill
              large
              @click.prevent="signIn"
            >
              {{ loginScreenButtonLabel }}
              <f7-preloader
                v-if="loginScreen.loading"
                color="white"
              ></f7-preloader>

              <f7-icon
                v-else
                f7="arrow_right"
                color="white"
                size="24"
              ></f7-icon>
            </f7-button>
          </f7-block>
        </f7-page>
      </f7-view>
    </f7-login-screen>
  </f7-app>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { merge, isEmpty } from 'lodash';
import { loadLanguageAsync } from '@/js/i18n.js';
import routes from '@/js/routes.js';
import notify from '@/js/helpers/notify.js';
import apiRequest from '@/js/helpers/apiRequest.js';
import validateEmail from '@/js/helpers/validateEmail.js';
import setTokenToLocalStorage from '@/js/helpers/setTokenToLocalStorage.js';
import removeTokenFromLocalStorage from '@/js/helpers/removeTokenFromLocalStorage.js';
import isTokenExpired from '@/js/helpers/isTokenExpired.js';

import CodeInput from 'vue-verification-code-input';
import UserInfoItem from './UserInfoItem.vue';
import CreatorsAreaBanner from './CreatorsAreaBanner.vue';

export default {
  name: 'App',

  components: {
    CodeInput,
    UserInfoItem,
    CreatorsAreaBanner,
  },

  data() {
    return {
      f7params: {
        name: 'Reallang Online',
        theme: 'aurora',
        routes: routes,
        view: {
          // pushState: true,
          // pushStateSeparator: '#',
        },
      },

      loginScreen: {
        step: 1,
        phone: { value: '', error: null },
        name: { value: '', error: null },
        lastName: { value: '', error: null },
        email: { value: '', error: null },
        referral: { value: '', error: null },
        smsCode: '',
        loginId: null,
        loading: false,
      },
    };
  },

  computed: {
    loginScreenTitle() {
      const result = {};

      switch (this.loginScreen.step) {
        case 1:
          result.title = this.$t(`page_sign_in.phone_number_slide.title`);
          result.subtitle = this.$t(
            `page_sign_in.phone_number_slide.description`
          );
          break;
        case 2:
          result.title = this.$t(`page_sign_in.security_code_slide.title`);
          result.subtitle = this.$t(
            `page_sign_in.security_code_slide.description`
          );
          break;
        default:
          result.title = '';
          result.subtitle = '';
      }

      return result;
    },

    loginScreenButtonLabel() {
      return this.loginScreen.step === 1
        ? this.$t(`get_code`)
        : this.$t(`log_in`);
    },

    ...mapState({
      user: (state) => state.user.info,
      userCoursesCount: (state) => state.user.userCoursesCount,
      showCreatorsAreaBanner: (state) => state.user.showCreatorsAreaBanner,
      purchasedCourseCount: (state) => state.course.purchased.length,
      favoritesCourseCount: (state) => state.course.favorites.length,
    }),
  },

  async created() {
    this.getAppConfig();
    this.getTerms();
  },

  mounted() {
    this.$f7ready(async () => {
      const pathname = window.location.pathname.replace('/', '');
      const params = this.$f7.utils.parseUrlQuery(window.location.href);

      if (['en', 'ru', 'es', 'pt'].indexOf(pathname) > 0) {
        loadLanguageAsync(pathname);
        localStorage.setItem('lang', pathname);
      } else if (params && params.lang) {
        loadLanguageAsync(params.lang);
        localStorage.setItem('lang', params.lang);
      } else {
        if (localStorage.getItem('lang')) {
          loadLanguageAsync(localStorage.getItem('lang'));
        } else {
          const locale = navigator.language.substring(0, 2).toLowerCase();
          loadLanguageAsync(locale);
          localStorage.setItem('lang', locale);
        }
      }

      if (params && params.course) {
        this.$f7.views.main.router.navigate(`/course/${params.course}`);
      }

      this.$nextTick(() => {
        const pageContent = this.$$('.page:not(.page-previous) .page-content');
        pageContent.on('scroll', this.handleScroll);
      });

      this.$f7.views.main.on('routeChange', () => {
        this.$$('.page.page-previous .page-content').off(
          'scroll',
          this.handleScroll
        );

        this.$nextTick(() => {
          const pageContent = this.$$(
            '.page:not(.page-previous) .page-content'
          );
          pageContent.on('scroll', this.handleScroll);
        });
      });

      if (localStorage.getItem('access_token') && !isTokenExpired()) {
        await this.getUserInfo();
        this.getUserCoursesBalance();
        this.getPurchasedCourses();
        this.getFavoriteCourses();
        this.getAmounts();
      } else {
        removeTokenFromLocalStorage();
      }
    });
  },

  methods: {
    validate() {
      const errors = {};
      const { name, lastName, email } = this.loginScreen;

      // Reset old errors
      name.error = null;
      lastName.error = null;
      email.error = null;

      if (!name.value) {
        errors.name = this.$t(`form_fields.errors.enter_name`);
      }

      if (!lastName.value) {
        errors.lastName = this.$t(`form_fields.errors.enter_last_name`);
      }

      if (!validateEmail(email.value)) {
        errors.email = this.$t(`form_fields.errors.enter_correct_email`);
      }

      if (!email.value) {
        errors.email = this.$t(`form_fields.errors.enter_email`);
      }

      if (isEmpty(errors)) {
        return true;
      }

      // Formating
      Object.keys(errors).forEach((error) => {
        errors[error] = {
          error: errors[error],
        };
      });

      merge(this.loginScreen.name, errors.name);
      merge(this.loginScreen.lastName, errors.lastName);
      merge(this.loginScreen.email, errors.email);
    },

    next() {
      this.loginScreen.step++;
    },

    async signIn() {
      const { step } = this.loginScreen;

      if (step === 1) {
        const { phone } = this.loginScreen;

        if (!phone.value) {
          phone.error = this.$t(`form_fields.errors.field_required`);
          return;
        }

        phone.error = '';

        this.loginScreen.loading = true;

        try {
          const body = new FormData();
          // eslint-disable-next-line no-useless-escape
          body.append('phone', phone.value.replace(/\+|\-/g, ''));

          const res = await apiRequest('sendLoginSms', 'POST', body);

          this.loginScreen.loading = false;

          if (res.error) {
            notify({ text: res.error });
            return;
          }

          const { login_id: loginId } = res.success;

          this.loginScreen.loginId = loginId;
          localStorage.setItem('loginId', loginId);
          this.next();
        } catch (error) {
          this.loginScreen.loading = false;
          console.error(error);
          notify({ text: this.$t(`notify.something_went_wrong`) });
        }
      } else if (step === 2) {
        const { loginId, smsCode } = this.loginScreen;

        if (!smsCode && smsCode.length !== 4) {
          notify({ text: this.$t(`form_fields.errors.field_required`) });
          return;
        }

        this.loginScreen.loading = true;

        try {
          const body = new FormData();

          body.append('login_id', loginId || localStorage.getItem('loginId'));
          body.append('code', smsCode);

          const res = await apiRequest('loginByCode', 'POST', body);

          if (res.error) {
            notify({ text: res.error });
            this.loginScreen.loading = false;
            return;
          }

          localStorage.removeItem('loginId');
          this.loginScreen.smsCode = '';
          setTokenToLocalStorage(res.success.token);

          await this.getUserInfo();
          await this.getAmounts();
          this.getUserCoursesBalance();

          if (!this.user.name || !this.user.lastName || !this.user.email) {
            this.user.name
              ? (this.loginScreen.name.value = this.user.name)
              : null;
            this.user.lastName
              ? (this.loginScreen.lastName.value = this.user.lastName)
              : null;
            this.user.email
              ? (this.loginScreen.email.value = this.user.email)
              : null;

            this.loginScreen.loading = false;
            this.next();
          } else {
            await this.getUserInfo();
            this.getUserCoursesBalance();
            this.loginScreen.loading = false;
            this.$f7.loginScreen.close('#loginScreen');
          }
        } catch (error) {
          this.loginScreen.loading = false;
          console.error(error);
          notify({ text: this.$t(`notify.something_went_wrong`) });
        }
      } else if (step === 3) {
        if (!this.validate()) {
          return;
        }

        const { name, lastName, email, referral } = this.loginScreen;

        this.loginScreen.loading = true;

        try {
          const body = new FormData();
          body.append('name', name.value);
          body.append('last_name', lastName.value);
          body.append('email', email.value);
          body.append('ref_code', referral.value);

          const res = await apiRequest('saveUserData', 'POST', body, true);

          if (res.error) {
            notify({ text: res.error });
            this.loginScreen.loading = false;
            return;
          }

          await this.getUserInfo();
          this.getUserCoursesBalance();
          this.loginScreen.loading = false;
          this.$f7.loginScreen.close('#loginScreen');
        } catch (error) {
          this.loginScreen.loading = false;
          console.error(error);
          notify({ text: this.$t(`notify.something_went_wrong`) });
        }
      }
    },

    handleLoginscreenClose() {
      const { phone, name, lastName, email, referral } = this.loginScreen;

      if (localStorage.getItem('access_token') && !isTokenExpired()) {
        this.getPurchasedCourses();
        this.getFavoriteCourses();
      }

      this.loginScreen.step = 1;
      this.loginScreen.smsCode = '';
      phone.value = '';
      name.value = '';
      lastName.value = '';
      email.value = '';
      referral.value = '';
    },

    handleScroll() {
      const pageContent = this.$$('.page:not(.page-previous) .page-content');
      if (pageContent.scrollTop() > 0) {
        this.$$('.navbar-bg')[0].style.setProperty(
          '--f7-navbar-bg-color',
          '#ffffff'
        );
      } else {
        this.$$('.navbar-bg')[0].style.setProperty(
          '--f7-navbar-bg-color',
          'transparent'
        );
      }
    },

    setLang(locale) {
      loadLanguageAsync(locale);
      localStorage.setItem('lang', locale);
    },

    logout() {
      this.$f7.dialog.confirm(
        this.$t(`page_profile.want_sign_out`),
        this.$t(`log_out`),
        () => {
          removeTokenFromLocalStorage();

          this.$f7.views.main.router.navigate('/', {
            reloadAll: true,
          });
          this.setUserInfo(null);
          this.setPurchasedCourses([]);
          this.setAmounts([]);
        }
      );
    },

    ...mapActions({
      getAppConfig: 'getAppConfig',
      getTerms: 'getTerms',
      getAmounts: 'getAmounts',
      getUserInfo: 'user/getUserInfo',
      getUserCoursesBalance: 'user/getUserCoursesBalance',
      getPurchasedCourses: 'course/getPurchasedCourses',
      getFavoriteCourses: 'course/getFavoriteCourses',
    }),

    ...mapMutations({
      setUserInfo: 'user/SET_USER_INFO',
      setAmounts: 'SET_AMOUNTS',
      setPurchasedCourses: 'course/SET_PURCHASED_COURSES',
    }),
  },
};
</script>
